module.exports = __webpack_public_path__ + "img/smileyvert_on.e8dd0054.gif";